import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './hamburger_button.scss';

class HamburgerButton extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);

    this.HAMBURGER_STATES = {
      ACTIVE: 'active',
      INACTIVE: 'inactive',
    };

    const hamburgerInitialState = props.isActive
      ? this.HAMBURGER_STATES.ACTIVE
      : this.HAMBURGER_STATES.INACTIVE;

    this.state = {
      hamburgerState: hamburgerInitialState,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { isActive: willBeActive } = nextProps;
    const { isActive } = this.props;

    if (isActive !== willBeActive) {
      const hamburgerNextState = willBeActive
        ? this.HAMBURGER_STATES.ACTIVE
        : this.HAMBURGER_STATES.INACTIVE;

      this.setState({
        hamburgerState: hamburgerNextState,
      });
    }
  }

  onClick() {
    const { onClick } = this.props;

    this.setState(({ hamburgerState }) => {
      const newState =
        hamburgerState === this.HAMBURGER_STATES.ACTIVE
          ? this.HAMBURGER_STATES.INACTIVE
          : this.HAMBURGER_STATES.ACTIVE;

      return {
        hamburgerState: newState,
      };
    }, onClick);
  }

  render() {
    const { hamburgerState } = this.state;

    return (
      <button
        className={`hamburger-button hamburger-button--${hamburgerState}`}
        onClick={this.onClick}
        type="button"
      >
        <span className="hamburger-button__bar-1" />
        <span className="hamburger-button__bar-2" />
        <span className="hamburger-button__bar-3" />
      </button>
    );
  }
}

HamburgerButton.propTypes = {
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};

HamburgerButton.defaultProps = {
  isActive: false,
  onClick: () => {},
};

export default HamburgerButton;
